import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { quickWebLogger } from '@quickweb/logger';
import { firstValueFrom, timeout } from 'rxjs';
import { LoggerService } from 'src/app/core/services/logger.service';
import { VERSION } from 'src/environments/version';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  intialization = false;
  constructor(
    readonly loggerService: LoggerService,
    private http: HttpClient,
  ) {}

  private async verifyCertificateNetwork(): Promise<boolean> {
    try {
      const datadogMaxTimeout = 6000; // 6 segundos
      await firstValueFrom(
        this.http
          .get(environment.datadogProxyCheckerUrl, { responseType: 'text' })
          .pipe(timeout(datadogMaxTimeout)),
      );

      return true; // ✅ only 200 goes here
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        return error.status === 404 || error.status === 403;
      }

      return false; // ✅ fallback for anything unexpected
    }
  }

  private getDataDogExternalAppliaction(isVerifyEnviroment: boolean): boolean {
    if (isVerifyEnviroment === true) return false;
    return true;
  }

  private getDataDogClientToken(isVerifyEnviroment: boolean): string {
    if (isVerifyEnviroment === true) {
      return environment.dataDogInternalClientToken;
    }
    return environment.dataDogExternalClientToken;
  }

  public async init() {
    if (this.intialization === true) return;
    this.intialization = true;

    const isVerifyEnviroment = await this.verifyCertificateNetwork();
    const externalApplication =
      this.getDataDogExternalAppliaction(isVerifyEnviroment);
    const clientToken = this.getDataDogClientToken(isVerifyEnviroment);

    this.loggerService.info('Datadog environment: ' + environment.name);
    this.loggerService.info('Datadog externalApplication', externalApplication);
    try {
      quickWebLogger.init({
        name: 'ps7-agent-iframe',
        version: VERSION,
        env: environment.name === 'local' ? 'dev' : environment.name,
        sigla: 'ps7',
        datadog: {
          logs: {
            clientToken: clientToken,
            sessionSampleRate: 100,
            maskSensitiveData: false,
            beforeSend: (event) => {
              event.ddtags += `,account_id:${environment.aws_account_id},dd_account_id:${environment.aws_account_id}`;
              if (!environment.production) event.ddtags += `,sigla:ps7`;
              return true;
            },
          },
          rum: {
            applicationId: environment.datadogAppId,
            clientToken: clientToken,
            sessionSampleRate: 5, // 5 ponpmnpm
          },
        },
        externalApplication: externalApplication,
      });
    } catch {
      this.loggerService.error('não consegui iniciar o data dog');
    }
  }

  sendDataWithTimeout(callback: () => void): void {
    setTimeout(() => {
      callback();
    }, 3000);
  }
}
